/* eslint-disable */
'use strict';

const Article = {
    init: function() {
        this.handleSocialMediaShare();
    },

    handleSocialMediaShare: ()=> {
            var shareButtons = {
                facebook: document.getElementById('share-facebook'),
                linkedin: document.getElementById('share-linkedin'),
                twitter: document.getElementById('share-twitter'),
                email: document.getElementById('share-email'),
                shareNeededInfo: document.querySelector('.blog-article__share-btn-links')
            };
            
            if(shareButtons.shareNeededInfo) {
                var articleTitle = shareButtons.shareNeededInfo.getAttribute("data-title");
                var articleURL = shareButtons.shareNeededInfo.getAttribute("data-url");

                shareButtons.facebook.addEventListener('click', function () {
                    var facebookURL = 'https://www.facebook.com/sharer/sharer.php?u=' + 'https://www.healthycell.com/' + encodeURIComponent(articleURL);
                       window.open(facebookURL, '_blank', 'width=800,height=600');
                   });
           
                   shareButtons.linkedin.addEventListener('click', function () {
                       var linkedinURL = 'https://www.linkedin.com/shareArticle?mini=true&url=' + 'https://www.healthycell.com/' + encodeURIComponent(articleURL);
                       window.open(linkedinURL, '_blank', 'width=800,height=600');
                   });
           
                   shareButtons.twitter.addEventListener('click', function () {
                       var twitterURL = 'https://twitter.com/intent/tweet?url=' + 'https://www.healthycell.com/' + encodeURIComponent(articleURL);
                       window.open(twitterURL, '_blank', 'width=800,height=600');
                   });
           
                   shareButtons.email.addEventListener('click', function () {
                       var emailSubject = encodeURIComponent("Check out this article: " + articleTitle);
                       var emailBody = encodeURIComponent("I found this article interesting and thought you might like it: \n" + 'https://www.healthycell.com/' + articleURL);
                       var emailURL = 'mailto:?subject=' + emailSubject + '&body=' + emailBody;
                       window.location.href = emailURL;
                   });
            }
    }
}; 

export default Article;
